import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

export const StatCard = ({ label, value, hint, accent, info }) => (
  <Paper
    elevation={0}
    className={`fleetbot-stat ${accent ? "is-accent" : ""}`}
    sx={{
      p: 1.25,
      borderRadius: 2,
      bgcolor: accent ? "rgba(30, 114, 184, 0.1)" : "action.hover",
    }}
  >
    <Box className="fleetbot-stat-label">
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {info ? (
        <Tooltip
          title={info}
          placement="top"
          arrow
          enterTouchDelay={0}
          PopperProps={{ style: { zIndex: 10000 } }}
        >
          <IconButton size="small" className="fleetbot-info-btn" aria-label={label}>
            <InfoOutlinedIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
    <Typography className="fleetbot-stat-value" variant="subtitle2">
      {value}
    </Typography>
    {hint ? (
      <Typography className="fleetbot-stat-hint" variant="caption" color="text.secondary">
        {hint}
      </Typography>
    ) : null}
  </Paper>
);

export const ComparisonBar = ({
  spent,
  saved,
  spentLabel,
  savedLabel,
  savedTone = "saved",
}) => {
  const total = Number(spent) + Number(saved);
  const spentPct = total > 0 ? (Number(spent) / total) * 100 : 0;
  const savedPct = total > 0 ? (Number(saved) / total) * 100 : 0;
  const savedClass = savedTone === "pending" ? "is-pending" : "is-saved";

  return (
    <Box className="fleetbot-compare">
      <Box className="fleetbot-compare-bar" aria-hidden="true">
        <Box className="is-spent" sx={{ width: `${spentPct}%` }} />
        <Box className={savedClass} sx={{ width: `${savedPct}%` }} />
      </Box>
      <Box className="fleetbot-compare-legend">
        <Typography variant="caption" component="span">
          <i className="dot is-spent" />
          {spentLabel}
        </Typography>
        <Typography variant="caption" component="span">
          <i className={`dot ${savedClass}`} />
          {savedLabel}
        </Typography>
      </Box>
    </Box>
  );
};

export const ListRow = ({ title, meta, value, badge, badgeTone }) => (
  <Paper elevation={0} className="fleetbot-row" variant="outlined" sx={{ borderRadius: 2 }}>
    <Box className="fleetbot-row-main">
      <Typography className="fleetbot-row-title" variant="body2" fontWeight={600}>
        {title}
      </Typography>
      {meta ? (
        <Typography className="fleetbot-row-meta" variant="caption" color="text.secondary">
          {meta}
        </Typography>
      ) : null}
    </Box>
    <Box className="fleetbot-row-side">
      {value ? (
        <Typography className="fleetbot-row-value" variant="caption" fontWeight={600}>
          {value}
        </Typography>
      ) : null}
      {badge ? (
        <Chip
          size="small"
          label={badge}
          color={badgeTone === "is-ok" ? "success" : badgeTone === "is-warn" ? "warning" : "default"}
          sx={{ height: 20, fontSize: 10, mt: 0.5 }}
        />
      ) : null}
    </Box>
  </Paper>
);

export const vehicleLabel = (item) =>
  item?.name || item?.vehicleName
    ? `${item.name || item.vehicleName} · ${item.plateNumber}`
    : item?.plateNumber || "—";
